type FlatTypedField = { type?: string; value?: unknown } | undefined

/** Server-only — стрипаем всегда */
const ALWAYS_STRIP_SUFFIXES = ['__selected', '__showMessageDialog', '__direction'] as const

/** Position cursors — Long N от сервера стрипаем, Boolean true от action.onClick оставляем. */
const POSITION_SUFFIXES = ['__nextSearchPosition', '__prevSearchPosition'] as const

function endsWithAny(name: string, suffixes: readonly string[]): boolean {
  for (const s of suffixes) {
    if (name.endsWith(s)) return true
  }
  return false
}

function isBooleanTrue(field: FlatTypedField): boolean {
  if (!field || typeof field !== 'object') return false
  return field.type === 'Boolean' && field.value === true
}

function isSingleUnderscoreSelectedServerShape(name: string, field: FlatTypedField): boolean {
  if (!name.endsWith('_selected') || name.endsWith('__selected')) return false
  if (!field || typeof field !== 'object') return false
  return field.type === 'UniDataTable' || field.type === 'Boolean'
}

/**
 * Мутирует переданный flat field map (currentData.fields.fields).
 */
export function stripTreeTableServerOnlyAuxFromFlatFields(
  fields: Record<string, FlatTypedField> | null | undefined,
): void {
  if (!fields || typeof fields !== 'object') return
  for (const key of Object.keys(fields)) {
    if (endsWithAny(key, ALWAYS_STRIP_SUFFIXES)) {
      delete fields[key]
      continue
    }
    if (endsWithAny(key, POSITION_SUFFIXES)) {
      if (!isBooleanTrue(fields[key])) {
        delete fields[key]
      }
      continue
    }
    if (isSingleUnderscoreSelectedServerShape(key, fields[key])) {
      delete fields[key]
    }
  }
}

/**
 * Стрип на верхнем уровне payload'а — для `currentData.fields.fields`.
 * Тип шире `unknown`, чтобы безболезненно прокидывать sanitizedData из api.service.
 */
export function stripTreeTableServerOnlyAuxFromPlatformRequest(payload: unknown): void {
  if (!payload || typeof payload !== 'object') return
  const currentData = (payload as { currentData?: unknown }).currentData
  if (!currentData || typeof currentData !== 'object') return
  const fieldsLevel1 = (currentData as { fields?: unknown }).fields
  if (!fieldsLevel1 || typeof fieldsLevel1 !== 'object') return
  const fieldsLevel2 = (fieldsLevel1 as { fields?: unknown }).fields
  if (!fieldsLevel2 || typeof fieldsLevel2 !== 'object') return
  stripTreeTableServerOnlyAuxFromFlatFields(fieldsLevel2 as Record<string, FlatTypedField>)
}
